import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import axios from 'axios';
import { Button, Popover, Spin, Tag } from 'antd';
import { axiosErrorHandler, nonEmpty } from "../../../../../swzutils";
import { CurrencyFormat } from '../../../components/FormattersTS';
import ConsignmentFreightPopover from "../ConsignmentFreightPopover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons/faCircleInfo';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import PaginatedFilterableTable, {} from "../../../components/table/PaginatedFilterableTable";
import DateRangeDescription from "../../../components/DateRangeDescription";
const columns = [{
        title: 'Action',
        dataIndex: 'existingConsignmentId',
        width: "5%",
        render: (text, record) => {
            if (record.existingConsignmentId) {
                return (_jsx(Tag, { color: "#f2930c", children: "UPDATE" }));
            }
            return (_jsx(Tag, { color: "#87d068", children: "INSERT" }));
        }
    }, {
        title: 'Delivery Date',
        key: 'deliveryDate',
        dataIndex: 'deliveryDate',
        width: "10%",
        render: (text, record) => (_jsx(DateRangeDescription, { fromISOTimestamp: record.deliveryFrom, toISOTimestamp: record.deliveryTo }))
    }, {
        title: 'Con. No.',
        dataIndex: 'consignmentRef',
        width: "5%"
    }, {
        title: 'Rego',
        dataIndex: 'vehicleRegistration',
        render: (text, record) => {
            return record.assignedVehicle ? _jsx("span", { children: record.assignedVehicle.registration }) : null;
        },
        width: "5%"
    }, {
        title: 'Expediency',
        dataIndex: ['deliveryExpediency', 'description'],
        width: "10%"
    }, {
        title: 'Pref. Vehicle',
        dataIndex: ['preferredVehicleType', 'description'],
        width: "10%"
    }, {
        title: 'Sender',
        key: 'pickupAddress',
        render: (text, record) => (_jsxs("div", { children: [_jsx(Popover, { content: nonEmpty `${record.pickupAddressUnitOrFlat} ${record.pickupAddressStreet} ${record.pickupAddressSuburb}`, title: record.pickupCompanyName, children: _jsx(FontAwesomeIcon, { icon: faCircleInfo, className: "info-text", size: "2x", fixedWidth: true }) }), "\u00A0\u00A0", record.pickupCompanyName] })),
        width: "15%"
    }, {
        title: 'Customer',
        key: "customerName",
        dataIndex: 'customerName',
        width: "10%"
    }, {
        title: 'Receiver',
        key: 'deliveryAddress',
        render: (text, record) => {
            return (_jsxs("div", { children: [_jsx(Popover, { content: nonEmpty `${record.deliveryAddressUnitOrFlat} ${record.deliveryAddressStreet} ${record.deliveryAddressSuburb}`, title: record.deliveryCompanyName, children: _jsx(FontAwesomeIcon, { icon: faCircleInfo, className: "info-text", size: "2x", fixedWidth: true }) }), "\u00A0\u00A0", record.deliveryAddressSuburb] }));
        },
        width: "15%"
    }, {
        title: 'Freight',
        width: "5%",
        render: (text, record) => (_jsx(ConsignmentFreightPopover, { consignment: record, forcePopover: false }))
    }, {
        title: 'Nom. Cost',
        dataIndex: 'nominatedCost',
        render: (text /*, record*/) => (_jsx(CurrencyFormat, { value: text })),
        width: "5%"
    }];
const PreviewStep = ({ active, importFile, onBack, onComplete }) => {
    const tableRef = useRef(null);
    const [showSpinner, setShowSpinner] = useState(false);
    const submitImport = () => {
        setShowSpinner(true);
        axios(`/admin/v1/consignments/imports/${importFile.id}/commit`, { method: "put", })
            .then(( /*response*/) => onComplete())
            .catch(axiosErrorHandler)
            .finally(() => setShowSpinner(false));
    };
    if (!active) {
        return null;
    }
    return (_jsxs(Spin, { spinning: showSpinner, children: [_jsxs("div", { className: "table-operations clearfix", children: [_jsx(Button, { type: "default", htmlType: "button", onClick: onBack, children: "\u00AB Back" }), _jsxs(Button, { className: "pull-right", type: "default", htmlType: "button", onClick: submitImport, children: [_jsx(FontAwesomeIcon, { icon: faCheck }), " Submit Import"] })] }), _jsx(PaginatedFilterableTable, { tableKey: 'importConsignmentsTable', ref: tableRef, dataUri: `/admin/v1/consignments/imports/${importFile.id}/consignments`, columns: columns })] }));
};
export default PreviewStep;
